import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden border-t border-slate-800 bg-blue-950 text-slate-100 pt-16 pb-8">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-5 pointer-events-none"
        style={{ 
          backgroundImage: `url('https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/898ac264-e288-4855-90ba-a9f48bcc4333/danish-male-welder-hero.jpg')` 
        }}
      />
      
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/">
              <span className="text-lg font-extrabold tracking-wider text-white uppercase">
                JC Svejseteknik
              </span>
            </Link>
            <div className="flex items-center gap-4 text-slate-400">
              <span className="text-xs font-semibold uppercase tracking-wider">Følg os:</span>
              <a href="#" className="text-slate-400 hover:text-brand-accent transition-colors" aria-label="Facebook">
                <i className="fa-brands fa-facebook text-lg" />
              </a>
              <a href="#" className="text-slate-400 hover:text-brand-accent transition-colors" aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin text-lg" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-6">Ydelser</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/ydelser/tig-svejsning" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  TIG-svejsning
                </Link>
              </li>
              <li>
                <Link to="/ydelser/co2-mig-mag" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  CO2 / MIG-MAG
                </Link>
              </li>
              <li>
                <Link to="/ydelser/industriservice" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  Industriservice
                </Link>
              </li>
              <li>
                <Link to="/ydelser/svejsning-i-aluminium" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  Svejsning i aluminium
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-6">Genveje</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/ydelser/tig-svejsning" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  TIG-svejsning
                </Link>
              </li>
              <li>
                <Link to="/ydelser/co2-mig-mag" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  CO2 / MIG-MAG
                </Link>
              </li>
              <li>
                <Link to="/ydelser/industriservice" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  Industriservice
                </Link>
              </li>
              <li>
                <Link to="/referencer" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  Referencer
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm text-slate-300 hover:text-brand-accent transition-colors">
                  Kontakt os
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-6">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-brand-accent mt-1" />
                <span className="text-sm text-slate-300">
                  Brandlundvej 11<br />7330 Brande
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-brand-accent" />
                <a href="tel:+4561167778" className="text-sm text-slate-300 hover:text-brand-accent transition-colors whitespace-nowrap">
                  +45 61 16 77 78
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-brand-accent" />
                <a href="mailto:info@jc-svejseteknik.dk" className="text-sm text-slate-300 hover:text-brand-accent transition-colors whitespace-nowrap">
                  info@jc-svejseteknik.dk
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-id-card text-brand-accent" />
                <span className="text-sm text-slate-300">
                  CVR nr.: 38970763
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="my-12 border-t border-slate-800" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© {currentYear} JC Svejseteknik. Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
}
